import React from 'react';
import { Caption } from '@randajan/jet-react/dom/caption';
import { Link } from '@randajan/jet-react/dom/link';
import { Reveal } from '../../elements/Reveal/Reveal';
import { useContact } from '../../frames/Contact/ContactProvider';

import logisticsImage from '../../images/photos/logisticComposit.png';
import itImage from '../../images/generated/nist2.png';
import telecommunicationsImage from '../../images/generated/teleco.png';
import energyImage from '../../images/photos/sklad4.jpg';

import "./ServicePage.scss";

const heroImages = {
    logistics: logisticsImage,
    "it-nis2": itImage,
    telecommunications: telecommunicationsImage,
    energy: energyImage
};

const optionalDefinitions = [
    { key:"targetGroups", title:"Cílové skupiny" },
    { key:"specializations", title:"Specializace" },
    { key:"customerGains", title:"Co zákazník získá" }
];

const getOptionalBlocks = service => optionalDefinitions
    .map(definition=>({
        title:definition.title,
        items:service[definition.key] || []
    }))
    .filter(block=>block.items.length);

export const ServicePage = (props)=>{
    const { service, services } = props;
    const { headline, lead, menuTitle, primaryItems, sections, summary, title } = service;
    const otherServices = services.filter(item=>item.id !== service.id);
    const optionalBlocks = getOptionalBlocks(service);
    const heroStyle = { backgroundImage:`url(${heroImages[service.id] || logisticsImage})` };

    const contact = useContact();

    return (
        <section className={`ServicePage ServicePage--${service.id}`}>
            <header className="ServicePage__hero" style={heroStyle}>
                <div className="ServicePage__overlay"></div>
                <article>
                    <span>{menuTitle}</span>
                    <Caption>{headline}</Caption>
                    <p>{lead}</p>
                    <small>{summary}</small>
                </article>
            </header>
            <main>
                <section className="ServicePage__section ServicePage__intro">
                    <article>
                        <span>Hlavní služby</span>
                        <Caption>{title}</Caption>
                        <div className="ServicePage__items">
                            {primaryItems.map((item, index)=>(
                                <Reveal className="ServicePage__itemWrap" key={item} delay={index * 50}>
                                    <strong>{item}</strong>
                                </Reveal>
                            ))}
                        </div>
                    </article>
                </section>
                <section className="ServicePage__section">
                    <article className="ServicePage__blocks">
                        {sections.map((section, index)=>(
                            <Reveal className="ServicePage__block" key={section.title} delay={index * 60}>
                                <h2>{section.title}</h2>
                                <ul>
                                    {section.items.map(item=><li key={item}>{item}</li>)}
                                </ul>
                            </Reveal>
                        ))}
                    </article>
                </section>
                {!!optionalBlocks.length && (
                    <section className="ServicePage__section ServicePage__optional">
                        <article className="ServicePage__blocks">
                            {optionalBlocks.map((block, index)=>(
                                <Reveal className="ServicePage__block" key={block.title} delay={index * 60}>
                                    <h2>{block.title}</h2>
                                    <ul>
                                        {block.items.map(item=><li key={item}>{item}</li>)}
                                    </ul>
                                </Reveal>
                            ))}
                        </article>
                    </section>
                )}
                <section className="ServicePage__section ServicePage__footer">
                    <Reveal as="article">
                        <div>
                            <span>Další krok</span>
                            <Caption>Probereme vhodné řešení pro váš projekt</Caption>
                            <Link className="ServicePage__cta" to={contact.link}>Kontaktovat ENERGOSPACE</Link>
                        </div>
                        <nav aria-label="Další služby">
                            {otherServices.map(item=>(
                                <Link key={item.id} to={item.route}>
                                    <strong>{item.menuTitle}</strong>
                                    <span>{item.headline}</span>
                                </Link>
                            ))}
                        </nav>
                    </Reveal>
                </section>
            </main>
        </section>
    )
}
